import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Tooltip,
  Typography,
  Checkbox,
} from "antd";
import { InfoCircleOutlined, PercentageOutlined } from "@ant-design/icons";
// import { SectionCard } from "../AddTreasuryBill";
import { useNavigate } from "react-router-dom";
import FeedbackModal from "../../bond/components/FeedbackModal";
import React, { useState } from "react";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import dayjs from "dayjs";
import SectionCard from "./SectionCard";

const { Text, Link, Title, Paragraph } = Typography;
export default function ProductInformation({
  setData,
  data,
  activePage,
  setActivePage,
  setHasModified,
  hasModifed,
  template,
}) {
  const navigate = useNavigate();
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [branchRestrictions, setBranchRestrictions] = useState();
  const [form] = Form.useForm();
  const selectedRestrictions = Form.useWatch("restrictedOffice", form);

  function handleValuesChange() {
    setHasModified && setHasModified([...hasModifed, activePage]);
  }

  function onFinish(_data) {
    setData({ ...data, ..._data });
    setActivePage(activePage + 1);
  }
  function onFinishFailed() {}
  function onCancel() {
    navigate("/treasury-bill", { replace: false });
  }
  const handleClose = () => {
    setShowWarningModal(true);
  };
  function handleGoBack() {
    navigate("/treasury-bill", { replace: false });
  }
  function onCancel() {
    setShowWarningModal(false);
  }

  const currency = Form.useWatch("currency", form);

  const defaultCurrency = template?.currencies?.find(
    (item) => item?.value === "NGN"
  );
  React.useEffect(() => {
    if (data) {
      if (!template) return;
      // form.setFieldsValue({ ...data });
      // form.setFieldsValue({ ...data, restrictedOffice: selectedRestrictions?.length === data?.restrictedOffice.length ? [0] : data.restrictedOffice });
      // if (selectedRestrictions?.length === data?.restrictedOffice.length) {
      //   console.log(selectedRestrictions?.length, data?.restrictedOffice.length);
      //   form.setFieldValue("restrictedOffice", [0]);
      // }
    } else {
      form.setFieldValue("currencyCode", defaultCurrency?.value);
    }
  }, [data, defaultCurrency]);

  React.useEffect(() => {
    const allExists = selectedRestrictions?.find((item) => item === 0);
    if (!template?.restrictions) return;

    if (allExists === 0) {
      setBranchRestrictions(
        branchRestrictions?.map((branch) => {
          if (branch.value === 0) {
            return { ...branch, label: "All Branches" };
          }
          return { ...branch, disabled: true };
        })
      );
      form.setFieldValue("restrictedOffice", [0]);
    } else {
      if (selectedRestrictions?.length === template?.restrictions?.length) {
        form.setFieldValue("restrictedOffice", [0]);
      }
      setBranchRestrictions([
        { value: 0, label: "All Branches" },
        ...template?.restrictions,
      ]);
    }
  }, [selectedRestrictions, template]);

  React.useEffect(() => {
    if (!template?.restrictions) return;
    if (!data && template.restrictions.find((item) => item.value === 1)) {
      form.setFieldsValue({
        restrictedOffice: [
          template.restrictions.find((item) => item.value === 1)?.value,
        ],
      });
      return;
    }
    // if (selectedRestrictions?.length === data?.restrictedOffice.length)
    form.setFieldsValue({
      ...data,
      restrictedOffice:
        data?.restrictedOffice?.length === template?.restrictions?.length
          ? [0]
          : data?.restrictedOffice,
    });
    // form.setFieldValue("restrictedOffice", [0]);
    // }
  }, [template, data]);

  const janFirst = dayjs().startOf("year");
  const today = dayjs();

  return (
    <SectionCard
      onPrev={handleClose}
      onNext={form.submit}
      nextTitle={"Next - Instrument Parameter"}
    >
      <Form
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        style={{ paddingTop: 0 }}
        onValuesChange={handleValuesChange}
      >
        <Title style={{ margin: 0, marginBottom: 5 }} level={3}>
          Product Information
        </Title>
        {/* <Text style={{ color: "#344054" }} color="#344054">
          Add description text to note for users when adding the ICF Information
        </Text> */}
        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col span={12}>
            {" "}
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Product code cannot be empty",
                },
                {
                  pattern: /^[A-Z0-9]+$/,
                  message:
                    "Product code must contain only uppercase letters, numbers and less than 5 characters",
                },
                {
                  max: 5,
                  message: "Product code must be less than 5 characters",
                },
              ]}
              name="productCode"
              label={
                <Text style={{ color: "#344054" }}>
                  Product Code{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Product code info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <Input
                className="custom-input"
                // size="large"
                placeholder="Enter product code"
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            {" "}
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Product Name cannot be empty",
                },
                {
                  min: 3,
                  message: "Product Name cannot be less than 3 characters",
                },
              ]}
              name="productName"
              label={
                <Text style={{ color: "#344054" }}>
                  Product Name{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Product Name info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <Input
                className="custom-input"
                // size="large"
                placeholder="Enter product name"
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            {" "}
            <Form.Item
              name="productCategory"
              rules={[
                {
                  required: true,
                  message: "Please select product category",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Product Category{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Product Category info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <Select
                // size="large"
                options={template?.productCategories}
                placeholder={"Select product category"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            {" "}
            <Form.Item
              initialValue={defaultCurrency?.value}
              rules={[{ required: true, message: "Please select currency" }]}
              name="currencyCode"
              label={
                <Text style={{ color: "#344054" }}>
                  Currency{" "}
                  <Tooltip>
                    <InfoCircleOutlined title="Currency info" color="#667085" />
                  </Tooltip>
                </Text>
              }
            >
              <Select
                // size="large"
                className="custom-input"
                // options={staticConfig.currencyOptions}
                options={template?.currencies}
                placeholder={"Select currency"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            {" "}
            <Form.Item
              label={
                <Text style={{ color: "#344054" }}>
                  Branch Restriction{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Restriction info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
              name="restrictedOffice"
              rules={[{ required: true, message: "Please select restriction" }]}
              validateTrigger={["onChange", "onBlur"]}
            >
              <Select
                mode="multiple"
                // onChange={(value) => handleInputChange('applicableEntities', value)}
                menuItemSelectedIcon={<Checkbox />}
                // popupClassName="custom-select-dropdown"
                options={branchRestrictions}
                placeholder={"Select restriction"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                style={{ width: "100%", height: 44 }}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Accounting Classification
                  <Tooltip title="Select accounting Classification">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="accountingClassification"
              rules={[
                {
                  required: true,
                  message: "Please select accounting classification",
                },
              ]}
            >
              <Select
                options={template?.accountingClassifications}
                placeholder={"Select accounting classification"}
                style={{ height: 44 }}
                showSearch
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Custodian
                  <Tooltip title="Select custodian">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="custodian"
              rules={[
                {
                  required: true,
                  message: "Please select custodian",
                },
              ]}
            >
              <Select
                options={template?.custodians}
                placeholder={"Select custodian"}
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<Text style={{ color: "#344054" }}>Start Date</Text>}
              name="startDate"
              style={{
                flex: 1,
                marginBottom: 0,
              }}
              rules={[
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject(
                        new Error(`Please select start date`)
                      );
                    }
                    if (value?.isBefore(janFirst, "day")) {
                      return Promise.reject(
                        new Error(
                          `Start date cannot be lesser than ${janFirst.format(
                            "YYYY-MM-DD"
                          )}`
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              // ]}
              validateTrigger={["onChange", "onBlur"]}
            >
              <DatePicker
                disabledDate={(current) => {
                  const startOfYear = dayjs().startOf("year");
                  return (
                    current && (current > dayjs() || current < startOfYear)
                  );
                }}
                // size="large"
                style={{ marginBottom: 0, width: "100%" }}
                placeholder="Select date"
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
                className="bond-date-picker custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<Text style={{ color: "#344054" }}>End Date</Text>}
              name="endDate"
              style={{
                width: "100%",
                flex: 1,
                marginBottom: 0,
                // color: "#667085",
              }}
              rules={[
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject(
                        new Error(`Please select end date`)
                      );
                    }
                    if (value?.isBefore(today, "day")) {
                      return Promise.reject(
                        new Error(
                          `End date cannot be lesser than ${today.format(
                            "YYYY-MM-DD"
                          )} (Today)`
                        )
                      );
                    }
                    const startDate = form.getFieldValue("startDate");
                    if (
                      startDate &&
                      value?.isAfter(startDate.add(1, "year"), "day")
                    ) {
                      return Promise.reject(
                        new Error(
                          `End date must not be more than a year from the start date (${startDate
                            .add(1, "year")
                            .format("YYYY-MM-DD")})`
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              validateTrigger={["onChange", "onBlur"]}
            >
              <DatePicker
                style={{ marginBottom: 0, width: "100%" }}
                placeholder="Select date"
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
                className="bond-date-picker custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} />
        </Row>
      </Form>
      {/* Warning Modal */}
      <FeedbackModal
        visible={showWarningModal}
        type="warning"
        onPrimaryAction={handleGoBack}
        onSecondaryAction={onCancel}
        onClose={onCancel}
      />
    </SectionCard>
  );
}
